<template>
  <div>
    <component is="script" src="https://cdnjs.cloudflare.com/ajax/libs/html5-qrcode/2.3.8/html5-qrcode.min.js" async></component>
    <CCard>
      <CCardBody>

        <div class="row justify-content-between">
          <!-- First Card -->
          <div class="col-md-4 mb-3">
            <div class="custom-card blue-card">
              <div class="custom-card-body">
                <h5 class="custom-card-title">Jumlah Partisipan</h5>
                <p class="custom-card-text">
                  <!-- <span class="custom-card-count">{{ numberWithCommas(totalCount) }}</span> / 
                  <span class="custom-card-count">{{ numberWithCommas(countStatus1) }}</span> /  -->
                  <span class="custom-card-count">{{ count_participants.total_participants }}</span>
                </p>
              </div>
            </div>
          </div>

          <!-- Third Card -->
          <div class="col-md-4 mb-3">
            <div class="custom-card green-card">
              <div class="custom-card-body">
                <h5 class="custom-card-title">Jumlah Partisipan Checked In</h5>
                <p class="custom-card-text">
                  <span class="custom-card-count">{{ count_participants.total_participant_checkeds }}</span>
                </p>
              </div>
            </div>
          </div>

          <!-- Third Card -->
          <div class="col-md-4 mb-3">
            <div class="custom-card red-card">
              <div class="custom-card-body">
                <h5 class="custom-card-title">Jumlah Partisipan Belum Checked In</h5>
                <p class="custom-card-text">
                  <span class="custom-card-count">{{ count_participants.total_participant_not_checkeds }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col-10">
            <div class="row mb-3">
              <button
                class="btn btn-sm btn-primary ml-2"
                @click="addModal()"
              >
                <CIcon name="cilMedicalCross" />
                Tambah
              </button>

              <button
                class="btn btn-sm btn-primary ml-2"
                @click="addModalImport()"
              >
                <CIcon name="cilArrowThickToBottom" />
                Import
              </button>

              <button
                class="btn btn-sm btn-primary ml-2"
                @click="showScan()"
              >
                Scan QRCode
              </button>
             
              <label class="m-1 ml-3" for="">Select All : </label>
              <input
                type="checkbox"
                v-model="isSelectedAll"
                @change="checkAll()"
              />

              <select v-if="selectedItems.length > 0"
                  style="max-width: 200px"
                  class="form-control form-control-sm mx-2"
                  placeholder="Ketik disini"
                  v-model="selectedAction"
                  @change="changeActionSelected()"
                >
                <option value="0">Action Selected</option>
                <!-- <option value="1">Delete Items Selected</option> -->
                <option value="2">Export Excel Items Selected</option>
                <option value="3">Export Pdf Items Selected</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col-10">
            <div class="row mb-3">
              <label class="m-1 ml-3" for="">Search : </label>
              <input
                type="text"
                v-model="params.keyword"
                style="max-width: 200px"
                class="form-control form-control-sm mx-2"
                placeholder="Ketik disini"
              />
              <button @click="search()" class="btn btn-sm btn-success">
                Cari
              </button>
            </div>
          </div>
          <div class="col-2">
            <div class="row">
              <div class="col-12">
                <div class="input-group input-group-sm mb-3">
                  <div class="input-group-prepend">
                    <label class="input-group-text" for="inputGroupSelect01"
                      >Per Halaman</label
                    >
                  </div>
                  <select
                    class="custom-select"
                    style="max-width: 100px"
                    id="inputGroupSelect01"
                    v-model="params.row"
                    @change="getData()"
                  >
                    <!-- <option selected>Pilih...</option> -->
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="isSearching">
          <div class="col">
            <h3>
              <span class="badge bg-primary text-light text-bor my-auto">
                {{searchOn}}&nbsp;&nbsp;
                <span @click="searchOff" class="badge bg-light text-dark text-center" style="cursor: pointer">X</span>
              </span>
            </h3>
          </div>
        </div>

        <CDataTable
          class="table-striped"
          :items="computedItems"
          :fields="fields"
          sorter
        >
          <template #select="{ item }">
            <td class="py-2">
              <input 
                  type="checkbox"
                  @change="check(item)"
                  v-model="item.select"
                />
            </td>
          </template>
          <template #qr_code="{ item }">
            <td class="py-2">
              <CButton
                @click="showQrCode(item)"
                class="mr-2"
                color="primary"
                square
                size="sm"
              >
                Show Qrcode
              </CButton>
            </td>
          </template>
          <template #action="{ item }">
            <td class="py-2">
              <CButton
                @click="edit(item)"
                class="mr-2"
                color="warning"
                square
                size="sm"
              >
                Edit
              </CButton>
              <CButton @click="hapus(item)" color="danger" square size="sm">
                Delete
              </CButton>
            </td>
          </template>
        </CDataTable>
        <pagination
          v-if="total !== items.length"
          v-model="page"
          :records="total"
          :per-page="100"
          @paginate="pagination"
        />
      </CCardBody>
    </CCard>
    <CModal
      size="lg"
      :title="
        isUpdate ? 'Edit Partisipan' : 'Tambah Partisipan'
      "
      centered
      :color="isUpdate ? 'success' : 'primary'"
      :show.sync="createModal"
    >
      <div class="row">
        <div class="col-12">
          <CInput
            v-model="form.name"
            label="Nama Lengkap"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.city"
            label="Asal Kota"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.institution"
            label="Asal Instansi"
            placeholder="ketik disini"
          />
          <CInput
            v-model="form.table_number"
            label="Nomor Meja"
            placeholder="ketik disini"
          />
        </div>
      </div>
      <template slot="footer">
        <div>
          <button @click="cancel" class="btn btn-secondary mr-3">Batal</button>

          <button @click="submit" v-if="!isUpdate" class="btn btn-primary">
            Tambah Partisipan
          </button>
          <button @click="update" v-if="isUpdate" class="btn btn-primary">
            Update Partisipan
          </button>
        </div>
      </template>
    </CModal>
    <CModal
      size="lg"
      title="Import Data"
      centered
      color="primary"
      :show.sync="createModalImport"
    >
        <a href="Participant.xlsx" download class="btn btn-primary">Download format</a>
        <br /><br />
        <input
            type="file"
            class="form-control"
            ref="uploadFieldBefore"
            @change="selectFileImport"
          />
        <template slot="footer">
        <div>
          <button @click="cancelImport" class="btn btn-secondary mr-3">Batal</button>

          <button @click="importData" class="btn btn-primary">
            Proses Import
          </button>
        </div>
      </template>
    </CModal>

    <CModal
      size="md"
      title="QR Code Peserta"
      centered
      color="primary"
      :show.sync="showQrModal"
    >
      <div class="text-center">
        <div id="qrcode-container" class="d-flex justify-content-center"></div>
        <p class="mt-3">
          <strong>Data:</strong> {{ selectedQr }}
        </p>
      </div>

      <template #footer>
        <button
          v-if="selectedQr"
          @click="downloadQr"
          class="btn btn-success mr-2"
        >
          Download QR
        </button>
        <button @click="showQrModal = false" class="btn btn-secondary">
          Tutup
        </button>
      </template>
    </CModal>

  </div>
</template>

<script>
import * as data from "../../model/participant";
import { uploadImage } from "@/utils/fileUpload";
import FileSaver from "file-saver";

export default {
  data() {
    return {
      file: null,
      createModal: false,
      createBuktiBayar: false,
      createAkte: false,
      createFoto: false,
      createModalImport: false,
      createModalAssignToBatch: false,
      fields: [],
      isUpdate: false,
      items: [],
      selectedItems: [],
      selectedByName: [],
      isSelectedAll: false,
      selectedAction: 0,
      page: 1,
      total: 0,
      to: 0,
      form: {},
      user: JSON.parse(localStorage.getItem("user")),
      params: {
        sorttype: "desc",
        sortby: "id",
        row: 100,
        page: 1,
        keyword: "",
        category_id: "",
        event_id: ""
      },
      isSearching: false,
      searchOn: '',
      showQrModal: false,
      selectedQr: null,
      count_participants: []
    };
  },
  methods: {
    showScan() {
        this.$swal.fire({
            title: 'Silahkan Scan QR',
            html: `
                <div id="reader"></div>
                <input type="text" id="manualInput" placeholder="Masukkan No Qrcode jika tidak bisa scan" style="margin-top: 10px; width: 100%; padding: 8px; font-size: 16px;">
            `,
            showCancelButton: true,
            confirmButtonText: 'Lanjutkan',
            cancelButtonText: 'Batalkan',
        }).then((result) => {
            if (result.isConfirmed) {
                const manualCode = document.getElementById('manualInput').value;
                if (manualCode) {
                    const data = {
                        qr_code: manualCode,
                    };
                    this.$store.dispatch('participant/scanqrcode', data).then((resp) => {
                        console.log(resp);
                        this.getData();
                        // ✅ Tampilkan info peserta setelah berhasil scan
                        if (resp && resp.data) {
                            const peserta = resp.data;
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Scan Berhasil 🎉',
                                html: `
                                    <div style="text-align: left;">
                                        <p><b>Nama:</b> ${peserta.name || '-'}</p>
                                        <p><b>Kota:</b> ${peserta.city || '-'}</p>
                                        <p><b>Instansi:</b> ${peserta.institution || '-'}</p>
                                        <p><b>Nomor Meja:</b> ${peserta.table_number || '-'}</p>
                                    </div>
                                `,
                                confirmButtonText: 'OK'
                            });
                        }
                    });
                }
            }
        });

        let html5QRCodeScanner = new Html5QrcodeScanner(
            "reader", {
                fps: 10,
                qrbox: {
                    width: 200,
                    height: 200,
                },
                videoConstraints: {
                    facingMode: "environment",
                }
            }
        );

        const onScanSuccess = (decodedText, decodedResult) => {
            html5QRCodeScanner.clear();
            // this.processCode(decodedText);  // Automatically proceed with scanned code
            const data = {
                qr_code: decodedText, // Code from either QR scan or manual input
                // code_voucher: result.value
            };
            this.$store.dispatch('participant/scanqrcode', data).then((resp) => {
                console.log(resp);
                this.getData();
                this.$swal.close()

                // ✅ Tampilkan info peserta setelah berhasil scan
                if (resp && resp.data) {
                    const peserta = resp.data;
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Scan Berhasil 🎉',
                        html: `
                            <div style="text-align: left;">
                                <p><b>Nama:</b> ${peserta.name || '-'}</p>
                                <p><b>Kota:</b> ${peserta.city || '-'}</p>
                                <p><b>Instansi:</b> ${peserta.institution || '-'}</p>
                                <p><b>Nomor Meja:</b> ${peserta.table_number || '-'}</p>
                            </div>
                        `,
                        confirmButtonText: 'OK'
                    });
                }
            });
        };

        const onScanError = (error) => {
            console.log("Scan Error:", error);  // Optional error logging
        };

        // Render the QR code scanner
        html5QRCodeScanner.render(onScanSuccess, onScanError);
    },
    showQrCode(item) {
      if (item.qr_code && item.qr_code !== '') {
        this.selectedQr = item.qr_code;
        this.showQrModal = true;

        this.$nextTick(() => {
          const container = document.getElementById("qrcode-container");
          container.innerHTML = ""; // bersihkan QR lama

          // Buat QR Code baru
          const qr = window.qrcode(0, "L"); // typeNumber=0, errorCorrectionLevel=L
          qr.addData(item.qr_code);
          qr.make();

          // Render dalam <canvas> biar bisa didownload
          const canvas = document.createElement("canvas");
          const cellSize = 6; // besar kotak
          const margin = 8;

          const size = qr.getModuleCount() * cellSize + margin * 2;
          canvas.width = canvas.height = size;

          const ctx = canvas.getContext("2d");
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, size, size);

          ctx.fillStyle = "#000000";
          for (let row = 0; row < qr.getModuleCount(); row++) {
            for (let col = 0; col < qr.getModuleCount(); col++) {
              if (qr.isDark(row, col)) {
                ctx.fillRect(
                  col * cellSize + margin,
                  row * cellSize + margin,
                  cellSize,
                  cellSize
                );
              }
            }
          }

          container.appendChild(canvas);
        });
      } else {
        this.$toast.error("QR Code tidak tersedia untuk peserta ini");
      }
    },
    downloadQr() {
      const container = document.getElementById("qrcode-container");
      const canvas = container.querySelector("canvas");

      if (!canvas) {
        this.$toast.error("QR belum siap didownload");
        return;
      }

      const link = document.createElement("a");
      link.download = `qrcode_${this.selectedQr}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    },
    search() {
      if (this.params.keyword != "") {
        this.isSearching = true;
        this.getData();
        this.searchOn = this.params.keyword;
      } else {
        this.$toast.error("Inputan tidak boleh kosong !!");
      }
    },

    searchOff(){
      this.isSearching = false;
      this.params.keyword = '';
      this.getData();
    },

    submit() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("participant/add", this.form)
        .then(() => {
          this.$toast.success("Berhasil menambahkan data");
          loading.hide();
          this.createModal = false;
          this.form = {};
          this.getData();
        })
        .catch(() => {
          loading.hide();
        });
    },
    edit(item) {
      this.form = item;
      this.isUpdate = true;
      this.createModal = true;
    },
    cancel() {
      this.form = {};
      this.createModal = false;
    },
    update() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("participant/update", {
          id: this.form.id,
          data: this.form,
        })
        .then(() => {
          this.$toast.success("Berhasil merubah data ");
          loading.hide();
          this.createModal = false;
          this.form = {};
          this.getData();
        })
        .catch(() => {
          loading.hide();
        });
    },
    hapus(item) {
      if (confirm("Data akan dihapus !!")) {
        this.$store
          .dispatch("participant/delete", item.uuid)
          .then(() => {
            this.$toast.success("Berhasil menghapus data ");
            this.form = {};
            this.getData();
          })
          .catch((e) => {
            this.$toast.error(e);
            loading.hide();
          });
      }
    },
    getData() {
      this.countParticipant();
      var loading = this.$loading.show();
      this.$store
        .dispatch("participant/get", this.params)
        .then((resp) => {

          this.items = resp.data.data;
          this.total = resp.data.total;
          this.to = resp.data.to;

          // khusus untuk checkbox
          this.selectedItems = [];
          this.items.forEach(element => {
            if (this.isSelectedAll) {
              element.select = true;
              this.selectedItems.push(element.id);
            } else {
              element.select = false;
            }
          });
          loading.hide();
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
          loading.hide();
        });
    },
    countParticipant() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("participant/count")
        .then((resp) => {
          this.count_participants = resp.data;
          console.log(this.count_participants);
          loading.hide();
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
          loading.hide();
        });
    },
    addModal() {
      this.isUpdate = false;
      this.form = {}
      this.createModal = true;
    },
    addModalImport() {
      this.createModalImport = true;
    },
    pagination(page) {
      this.page = page;
      this.params.page = page;
      this.getData();
    },
    check(item) {
      if (item.select) {
        this.selectedItems.push(item.id);
      } else {
        const index = this.selectedItems.indexOf(item.id);
        this.selectedItems.splice(index, 1);
      }
    },
    checkAll() {
      this.getData();
    },
    changeActionSelected() {
      switch (Number(this.selectedAction)) {
        case 1:
          console.log('deleted')
          // this.deleteSelected('delete');
          break;
        case 2:
          console.log('export excel')
          this.exportExcel('export_excel');
          break;
        case 3:
          console.log('export pdf')
          this.exportPDF();
          break;
      }
    },
    deleteSelected(action) {
      var loading = this.$loading.show();
      this.$store
        .dispatch("participant/selectedAction", 
        {
          action: action,
          data: this.selectedItems,
        })
        .then(() => {
          this.$toast.success("Item Selected Berhasil diproses");
          loading.hide();
          this.createModal = false;
          this.form = {
          };
          this.getData();
        })
        .catch((e) => {
          this.$toast.error("gagal mengambil data  \n", e);
          loading.hide();
        });
    },
    openModalExcel() {
      this.exportModal = true;
      this.exportType = "Export Excel";
    },
    openModalPDF() {
      this.exportModal = true;
      this.exportType = "Export PDF";
    },
    exportExcel() {
      console.log({
          data: this.selectedItems,
        })
      var loading = this.$loading.show();
      this.$store
       .dispatch("participant/exportReport", {
          data: this.selectedItems,
        })
        .then((resp) => {
          loading.hide();
          FileSaver.saveAs(
            resp.data,
            "Participant"
          );
          this.exportModal = false;
          this.exportDataParams = {};
        })
        .catch(() => {
          loading.hide();
        });
    },
    exportPDF() {
      this.$router.push({ name: "ParticipantExportPDF", query: { data: this.selectedItems } });
    },
    selectFileImport(event) {
      this.file = event.target.files[0];
    },
    cancelImport() {
      this.file = null;
    },
    importData() {
      var loading = this.$loading.show();
      this.$store
        .dispatch("participant/import", this.file)
        .then((res) => {
          this.$toast.success(res.data.message);
          loading.hide();
          this.createModalImport = false;
          this.form = {};
          this.getData();
        })
        .catch((e) => {
          console.log(e)
          this.$toast.error(e);
          loading.hide();
        });
    },
  },
  computed: {
    computedItems() {  
      return this.items.map((item, index) => {
        return {
          index: (this.to - this.items.length) + index+1 + '.',
          ...item,
          clothes_size: item.event ? item.event.clothes_image ? item.clothes_size : '-' : '-',
          event_name: item.event ? item.event.event_name : '-',
          category: item.category ? item.category.name : '-',
          created_at: this.$moment(item.created_at).format("Do MMMM YYYY"),
          updated_at: this.$moment(item.updated_at).format("Do MMMM YYYY"),
        };
      });
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.fields = data.fields
  },
};
</script>

<style scoped>
.custom-card {
  border: 1px solid #dee2e6; /* Light border */
  border-radius: .375rem; /* Rounded corners */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  overflow: hidden; /* Ensure border-radius is applied */
}

.custom-card-body {
  padding: 1.25rem; /* Padding inside the card */
}

.custom-card-title {
  color: #ffffff; /* White text color for visibility on colored background */
}

.custom-card-text {
  font-size: 1rem; /* Text font size */
  color: #ffffff; /* White text color for visibility on colored background */
}

.custom-card-count {
  font-size: 1.5rem; /* Larger font size for counts */
  font-weight: 700; /* Bold text */
  color: #ffffff; /* White text color for visibility on colored background */
}
.blue-card {
  background-color: #007bff; /* Blue background */
}

.yellow-card {
  background-color: #ffc107; /* Yellow background */
}

.green-card {
  background-color: #28a745; /* Green background */
}

.red-card {
  background-color: #e55353; /* Green background */
}
</style>